import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export type LomavisConfirmationModalProps = {
  show: boolean;
  title: React.ReactNode;
  description: React.ReactNode;
  confirmLabel: React.ReactNode;
  cancelLabel: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  destructive?: boolean;
  confirming?: boolean;
};

/** A compact confirmation dialog for irreversible or interrupting actions. */
export const LomavisConfirmationModal: React.FC<
  LomavisConfirmationModalProps
> = ({
  show,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onClose,
  onConfirm,
  destructive = false,
  confirming = false
}) => (
  <Modal
    centered
    show={show}
    onHide={onClose}
    contentClassName="overflow-hidden rounded-4 border-0 shadow-lg"
  >
    <Modal.Header className="border-0 px-4 pb-1 pt-4" closeButton>
      <Modal.Title className="fs-5 fw-bold">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="px-4 pb-3 pt-2 text-muted">{description}</Modal.Body>
    <Modal.Footer className="border-0 gap-2 px-4 pb-4 pt-0">
      <Button variant="light" className="rounded-3 px-3" onClick={onClose}>
        {cancelLabel}
      </Button>
      <Button
        variant={destructive ? 'danger' : 'primary'}
        className="rounded-3 px-3 shadow-sm"
        disabled={confirming}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);
